import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api';

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 35000,
});

apiClient.interceptors.request.use((config) => {
  let token = '';
  const user = localStorage.getItem('user');
  if (user) {
    try {
      token = JSON.parse(user)?.token || '';
    } catch (e) { /* noop */ }
  }
  if (token && config.headers) config.headers['AuthorizationToken'] = token;
  return config;
});

class UserService {
  async updateIncomePercentage(userId, incomePercentage) {
    // send null to unset, otherwise clamp 0..100
    const body = {
      incomePercentage: incomePercentage === null ? null : Math.max(0, Math.min(100, Number(incomePercentage)))
    };
    const { data } = await apiClient.post(`/users/${userId}/income-percentage`, body);
    return data; // { message, incomePercentage }
  }

  async updateInstagramFollowers(userId, instagramFollowers) {
    const body = {
      instagramFollowers: instagramFollowers === null || instagramFollowers === '' ? null : Math.max(0, Number(instagramFollowers))
    };
    const { data } = await apiClient.post(`/users/${userId}/instagram-followers`, body);
    return data; // { message, instagramFollowers }
  }

  async updateNote(userId, note) {
    const body = {
      note: note === null || note === '' ? null : String(note)
    };
    const { data } = await apiClient.post(`/users/${userId}/note`, body);
    return data; // { message, note }
  }

  async getTrainers({
    skip = 0,
    limit = 20,
    keyword = '',
    filterBy = 'name',
    status = 'all',
    dateStart = '',
    dateEnd = '',
    sortBy = '',
    sortOrder = '',
  } = {}) {
    const { data } = await apiClient.get('/trainers', {
      params: {
        skip: String(skip),
        limit: String(limit),
        ...(keyword ? { keyword, filterBy } : {}),
        ...(status && status !== 'all' ? { status } : {}),
        ...(dateStart ? { dateStart } : {}),
        ...(dateEnd ? { dateEnd } : {}),
        ...(sortBy ? { sortBy, ...(sortOrder ? { sortOrder } : {}) } : {}),
      },
    });

    if (Array.isArray(data)) {
      return { items: data, total: data.length };
    }

    return {
      items: Array.isArray(data?.items) ? data.items : [],
      total: Number(data?.total) || 0,
    };
  }


  async acceptTrainer(userId) {
    const { data } = await apiClient.get(`/users/accept-trainer/${userId}`);
    return data; // { message: ... }
  }

  async declineTrainer(userId) {
    const { data } = await apiClient.get(`/users/decline-trainer/${userId}`);
    return data; // { message: ... }
  }
}

export default new UserService();
